
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 3C17.5 9 16 15 16 20L22 14C22 14 23 8.5 27 5L24 3Z"}}),_c('circle',{attrs:{"cx":"22","cy":"20","r":"6"}}),_c('path',{attrs:{"d":"M8 3C1.5 9 0 15 0 20L6 14C6 14 7 8.5 11 5L8 3Z"}}),_c('circle',{attrs:{"cx":"6","cy":"20","r":"6"}})])
          )
        }
      }
    